<div class="custom-modal modal-extrato-importacao">
    <div class="header">
      <h1 mat-dialog-title>
        Extrato de Importação
      </h1>
      <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="isLoading" class="d-flex justify-content-center">
        <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div mat-dialog-content class="content" *ngIf="!isLoading">
      <div class="d-flex flex-column">
        <span>Cliente: {{ importDetails?.cliente }}</span>
        <span>Produto: {{ importDetails?.produto }}</span>
        <span>Processo: PROCESSO</span>
        <span>Data: {{ importDetails?.data | date: 'dd/MM/yyyy' }}</span>
        <span>Arquivo: {{ importDetails?.arquivo }}</span>
      </div>
      <mat-divider></mat-divider>
      <span style="color: #ef5350;">{{ importDetails?.mensagem }}</span>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
      <button mat-flat-button mat-dialog-close color="primary">OK</button>
    </div>
  </div>